import React from "react";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="simple-404-container">
      <div className="simple-404-content">
        <div className="simple-404-code">404</div>
        <h1 className="simple-404-title">Page Not Found</h1>
        <p className="simple-404-desc">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <a href="/" className="simple-404-btn">
          Go to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
